export const setFilter = filter => ({
  type: 'WCP.SET_FILTER',
  filter
});

export const clearFilter = () => ({
  type: 'WCP.CLEAR_FILTER'
});
